<template>
  <v-app>
    <div>
        <!-- <h1>Регистрация прошла успешно!</h1> -->
        <p>Регистрация закончена, мы направили Вам инструкцую на электронную почту: <span>{{ $route.params.email }}</span></p>
    </div>
  </v-app>
</template>
<script>

export default {
  name: 'RegisterFinish',
};
</script>
<style scoped>
div{
  margin: 100px auto;
}
h1{
  margin: 50px auto;
  text-align: center;
}
p{
  font-size: 20px;
}
  span{
    font-weight: bold;
  }
</style>
